export enum PaymentMethodEnum {
  PIX = 'PIX',
  CASH = 'CASH',
  CREDIT_CARD = 'CREDIT_CARD',
  DEBIT_CARD = 'DEBIT_CARD',
  BANK_TRANSFER = 'BANK_TRANSFER',
  BOLETO = 'BOLETO',
  OTHER = 'OTHER',
}
